import CSSCalculator from "./CSSCalculator";
import NumCalculator from "./NumCalculator";
var genCalc = function genCalc(type, unitlessCssVar) {
  var Calculator = type === 'css' ? CSSCalculator : NumCalculator;
  return function (num) {
    return new Calculator(num, unitlessCssVar);
  };
};
export default genCalc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs/es/theme/calc/index.js
// module id = 1441
// module chunks = 0